import { useLocaleState, useRecordContext } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";

import { StatusBadge } from "../faromarket-shared/StatusBadge";
import { formatRelativeDate } from "../misc/RelativeDate";

const LEAD_STATUS_CHOICES = [
  { id: "new", name: "crm.faromarket.lead_status.new" },
  {
    id: "pending_required_data",
    name: "crm.faromarket.lead_status.pending_required_data",
  },
  { id: "qualified", name: "crm.faromarket.lead_status.qualified" },
  { id: "disqualified", name: "crm.faromarket.lead_status.disqualified" },
  { id: "converted", name: "crm.faromarket.lead_status.converted" },
  { id: "archived", name: "crm.faromarket.lead_status.archived" },
];

const ENV_CHOICES = [
  { id: "production", name: "crm.faromarket.environment.production" },
  { id: "staging", name: "crm.faromarket.environment.staging" },
  { id: "test", name: "crm.faromarket.environment.test" },
  { id: "audit", name: "crm.faromarket.environment.audit" },
];

const TEMPERATURE_CHOICES = [
  { id: "cold", name: "crm.faromarket.temperature.cold" },
  { id: "warm", name: "crm.faromarket.temperature.warm" },
  { id: "hot", name: "crm.faromarket.temperature.hot" },
];

const LeadFilters = [
  <SearchInput source="initial_message@ilike" alwaysOn />,
  <SelectInput source="status" choices={LEAD_STATUS_CHOICES} translateChoice />,
  <SelectInput source="environment" choices={ENV_CHOICES} translateChoice />,
  <SelectInput
    source="temperature"
    choices={TEMPERATURE_CHOICES}
    translateChoice
  />,
];

const StatusFromRecord = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.status} kind="lead_status" />;
};

const TemperatureFromRecord = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.temperature} kind="temperature" />;
};

const EnvironmentFromRecord = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.environment} kind="environment" />;
};

const RelativeDateField = () => {
  const record = useRecordContext();
  const [locale = "pt-BR"] = useLocaleState();
  if (!record?.created_at)
    return <span className="text-muted-foreground">—</span>;
  return <span>{formatRelativeDate(record.created_at, locale)}</span>;
};

export const LeadList = () => {
  return (
    <List
      perPage={25}
      sort={{ field: "created_at", order: "DESC" }}
      filter={{ is_test: false }}
      filters={LeadFilters}
    >
      <DataTable>
        <DataTable.Col source="status" label="resources.leads.fields.status">
          <StatusFromRecord />
        </DataTable.Col>
        <DataTable.Col
          source="company_id"
          label="resources.leads.fields.company_id"
        >
          <ReferenceField
            source="company_id"
            reference="companies"
            link={false}
          />
        </DataTable.Col>
        <DataTable.Col
          source="contact_id"
          label="resources.leads.fields.contact_id"
        >
          <ReferenceField
            source="contact_id"
            reference="contacts"
            link={false}
          />
        </DataTable.Col>
        <DataTable.Col
          source="service_interest_id"
          label="resources.leads.fields.service_interest_id"
        >
          <ReferenceField
            source="service_interest_id"
            reference="service_interests"
            link={false}
          />
        </DataTable.Col>
        <DataTable.Col
          source="main_pain"
          label="resources.leads.fields.main_pain"
        />
        <DataTable.Col
          source="temperature"
          label="resources.leads.fields.temperature"
        >
          <TemperatureFromRecord />
        </DataTable.Col>
        <DataTable.Col source="source" label="resources.leads.fields.source" />
        <DataTable.Col
          source="environment"
          label="resources.leads.fields.environment"
        >
          <EnvironmentFromRecord />
        </DataTable.Col>
        <DataTable.Col
          source="created_at"
          label="resources.leads.fields.created_at"
        >
          <RelativeDateField />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};
